import CryptoJS from 'crypto-js';

function encryptMethod(obj, att, key) {
  if (obj[att] && obj[att] != "") {
    try {
      let enc = CryptoJS.AES.encrypt(obj[att], key).toString()
      if (enc) {
        obj[att] = enc
      }
    } catch (ignore) {
    }
  }
  return obj
}
function decryptMethod(obj, att, key) {
  if (obj && obj[att] && obj[att] != "") {
    try {
      let dec = CryptoJS.AES.decrypt(obj[att], key).toString(CryptoJS.enc.Utf8)
      if (dec) {
        obj[att] = dec
      }
    } catch (ignore) { }
  }

  return obj
}

function cryptComment(comment, key, encrypt) {
  if (!comment) return false
  let crypt = encryptMethod
  if (!encrypt) crypt = decryptMethod;
  ["message"].forEach(att => {
    comment = crypt(comment, att, key)
  });
  comment.encrypted = encrypt
  return comment;
}

function cryptApplication(application, key, encrypt) {
  if (!application) return false
  let crypt = encryptMethod
  if (!encrypt) crypt = decryptMethod;
  ["name", "mail", "phone", "salary", "city", "birthdate", "comment"].forEach(att => {
    application = crypt(application, att, key)
  });
  if (application.pinnedComments) {
    application.pinnedComments.forEach((comment, i, a) => {
      a[i] = cryptComment(comment, key, encrypt)
    });
  }
  if (application.files) {
    application.files.forEach((file, i, a) => {
      a[i] = cryptFile(file, key, encrypt)
    });
  }
  if(encrypt) application.encrypted = encrypt
  return application
}

function cryptFile(file, key, encrypt) {
  if (!file) return false
  let crypt = encryptMethod
  if (!encrypt) crypt = decryptMethod;
  ["originalName", "name","data"].forEach(att => {
    file = crypt(file, att, key)
  });
  if(encrypt) file.encrypted = encrypt
  console.log(file)
  return file
}


export default {
  encryptComment: function (comment, key) {
    return cryptComment(JSON.parse(JSON.stringify(comment)), key, true)

  },
  decryptComment: function (comment, key) {
    return cryptComment(JSON.parse(JSON.stringify(comment)), key, false)
  },
  encryptApplication: function (application, key) {
    return cryptApplication(JSON.parse(JSON.stringify(application)), key, true)
  },
  decryptApplication: function (application, key) {
    return cryptApplication(JSON.parse(JSON.stringify(application)), key, false)
  },
  encryptFile: function (file, key) {
    return cryptFile(JSON.parse(JSON.stringify(file)), key, true)
  },
  decryptFile: function (file, key) {
    return cryptFile(JSON.parse(JSON.stringify(file)), key, false)
  },
  arrayBufferToBase64: function (arrayBuffer) {
    var base64 = "";
    var encodings =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

    var bytes = new Uint8Array(arrayBuffer);
    var byteLength = bytes.byteLength;
    var byteRemainder = byteLength % 3;
    var mainLength = byteLength - byteRemainder;

    var a, b, c, d;
    var chunk;

    for (var i = 0; i < mainLength; i = i + 3) {
      chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];

      a = (chunk & 16515072) >> 18;
      b = (chunk & 258048) >> 12;
      c = (chunk & 4032) >> 6;
      d = chunk & 63;

      base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d];
    }

    if (byteRemainder == 1) {
      chunk = bytes[mainLength];

      a = (chunk & 252) >> 2;

      b = (chunk & 3) << 4;

      base64 += encodings[a] + encodings[b] + "==";
    } else if (byteRemainder == 2) {
      chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1];

      a = (chunk & 64512) >> 10;
      b = (chunk & 1008) >> 4;

      c = (chunk & 15) << 2;

      base64 += encodings[a] + encodings[b] + encodings[c] + "=";
    }

    return base64;
  },
  b64toBlob: function (b64Data, contentType='', sliceSize=512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
  
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
      
    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
  },
  hashString: function (string) {
    var hash = 0, i, chr;
    if (string.length === 0) return hash;
    for (i = 0; i < string.length; i++) {
      chr = string.charCodeAt(i);
      hash = ((hash << 5) - hash) + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  }
}

